module.exports = __webpack_public_path__ + "static/media/Benefits-and-pirks.4df59110.svg";